import React from 'react'
import { Box } from '@mui/material'
import { AppProviderBlock } from '@components'


// providerLogo: the value is a provider, drawn with its logo
export default function staticColumn(name, label, filterType, displayFilters, display, providerLogo = false) {
	return {
		name,
		label,
		options: {
			filter: displayFilters,
			display: display,
			headAlign: 'center',
			filterType,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{providerLogo && value ? <AppProviderBlock provider={value}/> : (value || '-')}
			</Box>
		}
	}
}